<template>
  <div class="what-benefit">
    <div class="what-benefit__title main-title">
      <h2>
        {{ title }}
      </h2>
    </div>

    <div class="what-benefit__cards">
      <div
        v-for="item of cards"
        :key="item.id"
        :class="['what-benefit__card', item.className]"
      >
        <p v-html="item.text" />
      </div>
    </div>

    <div class="what-benefit__info">
      <h4 class="what-benefit__info--title">
        помогает плавно
        <br>
        и без стресса
        <span>
          выстроить путь в профессию <br class="br-tablet">уже с детства
        </span>
      </h4>

      <img
        src="/v2/school-new/what-benefit/benefit-photo.webp"
        alt="photo"
        class="what-benefit__info--photo"
      >

      <p
        class="what-benefit__info--description"
        v-html="description"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SchoolWhatBenefit',
  data: () => ({
    cards: [
      {
        id: 1,
        text: 'углубить знания <br>и <b>повысить успеваемость</b>',
        className: 'what-benefit__card--blue',
      },
      {
        id: 2,
        text: '<b>сдать егэ/огэ</b> <br>без проблем',
        className: 'what-benefit__card--orange',
      },
      {
        id: 3,
        text: '<b>поступить</b> <br>в профильный вуз <br>или колледж',
        className: 'what-benefit__card--green',
      },
      {
        id: 4,
        text: 'плавно начать <br><b>карьерный путь</b>',
        className: 'what-benefit__card--pink',
      },
    ],
  }),
  computed: {
    title() {
      const routeName = this.$route.name;

      switch (routeName) {
        case 'online-school-fiziko-matematicheskij':
          return 'какая польза от физмат класса?';
        case 'online-school-lingvisticheskij':
          return 'какая польза от лингвистического класса?';
        case 'online-school-gumanitarnyj':
          return 'какая польза от гуманитарного класса?';
        case 'online-school-socialno-ekonomicheskij':
          return 'какая польза от соц. экономического класса?';
        default:
          return '';
      }
    },
    description() {
      const routeName = this.$route.name;

      switch (routeName) {
        case 'online-school-fiziko-matematicheskij':
          // eslint-disable-next-line max-len,vue/max-len
          return 'обучаясь в&nbsp;физмат классе, ученики не&nbsp;только лучше понимают физику, информатику и&nbsp;математику, но&nbsp;и&nbsp;успешно сдают итоговые аттестации, огэ&nbsp;и&nbsp;егэ. В&nbsp;результате, у&nbsp;вас&nbsp;меньше времени уходит на&nbsp;подготовку по&nbsp;предметам, что&nbsp;снижает нагрузку для&nbsp;вас&nbsp;и&nbsp;ребенка';
        case 'online-school-lingvisticheskij':
          // eslint-disable-next-line max-len,vue/max-len
          return 'обучаясь в&nbsp;лингвистическом классе, ученики не&nbsp;только лучше понимают иностранный язык, но&nbsp;и&nbsp;успешно сдают итоговые аттестации по нему, огэ&nbsp;и&nbsp;егэ. В&nbsp;результате, у&nbsp;вас уходит меньше времени на&nbsp;изучение языка, что&nbsp;снижает нагрузку для&nbsp;вас&nbsp;и&nbsp;ребенка';
        case 'online-school-gumanitarnyj':
          // eslint-disable-next-line max-len,vue/max-len
          return 'обучаясь в&nbsp;гуманитарном классе, ученики не&nbsp;только лучше понимают русский язык и&nbsp;литературу, но&nbsp;и&nbsp;успешно сдают итоговые аттестации, огэ&nbsp;и&nbsp;егэ. В&nbsp;результате, у&nbsp;вас&nbsp;меньше времени уходит на&nbsp;подготовку по&nbsp;предметам, что&nbsp;снижает нагрузку для&nbsp;вас&nbsp;и&nbsp;ребёнка';
        case 'online-school-socialno-ekonomicheskij':
          // eslint-disable-next-line max-len,vue/max-len
          return 'обучаясь в&nbsp;соц. экономическом классе, ученики не&nbsp;только лучше понимают экономику, обществознание и&nbsp;повышают финансовую грамотность, но&nbsp;и&nbsp;успешно сдают итоговые аттестации, огэ&nbsp;и&nbsp;егэ, что&nbsp;снижает общую нагрузку для&nbsp;ребенка и&nbsp;родителя';
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.what-benefit {
  &__title {
    margin-bottom: 2.5rem;
  }

  &__cards {
    display: flex;
    flex-wrap: wrap;
    gap: calc(var(--scale) * 20);

    @include media-down($size-tablet) {
      gap: calc(var(--scale) * 8);
    }
  }

  &__card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    width: calc(25% - (var(--scale) * 60) / 4);
    min-height: calc(var(--scale) * 164);
    padding: calc(var(--scale) * 24) calc(var(--scale) * 30);

    background-color: $white-color;
    border-radius: calc(var(--scale) * 40);
    box-sizing: border-box;

    @include media-down($size-tablet) {
      width: calc(25% - (var(--scale) * 24) / 4);
      min-height: calc(var(--scale) * 128);
      padding: calc(var(--scale) * 12) calc(var(--scale) * 16);

      border-radius: calc(var(--scale) * 24);
    }

    @include media-down($size-mobile) {
      width: calc(50% - (var(--scale) * 8) / 2);
    }

    &--blue {
      background-color: #0B72BE;
    }

    &--orange {
      background-color: #FF9C12;
    }

    &--green {
      background-color: #22AE9D;
    }

    &--pink {
      background-color: #F199CE;
    }

    p {
      font-family: 'Onest', sans-serif;
      font-weight: 500;
      font-size: calc(var(--scale) * 32);
      line-height: 110%;
      color: rgba($white-color, .6);

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 18);
      }

      ::v-deep(b) {
        font-weight: 500;
        color: $white-color;
      }
    }
  }

  &__info {
    display: flex;
    padding: calc(var(--scale) * 32) calc(var(--scale) * 40) 0;
    margin-top: calc(var(--scale) * 20);
    position: relative;

    background-image: url('/v2/school-new/what-benefit/benefit-bg.webp');
    background-position: center center;
    background-size: cover;
    border-radius: calc(var(--scale) * 60);

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 20) calc(var(--scale) * 16) calc(var(--scale) * 82);

      border-radius: calc(var(--scale) * 24);
    }

    @include media-down($size-mobile) {
      flex-direction: column;
      padding: calc(var(--scale) * 16) calc(var(--scale) * 16) calc(var(--scale) * 182);
      overflow: hidden;
    }

    &--title {
      width: 29.1%;

      font-family: 'Onest', sans-serif;
      font-weight: 500;
      font-size: calc(var(--scale) * 64);
      line-height: 95%;
      letter-spacing: -0.02em;
      color: #02120F;

      @include media-down($size-tablet) {
        width: 50%;

        font-size: calc(var(--scale) * 28);
      }

      @include media-down($size-mobile) {
        width: 100%;
      }

      span {
        color: #A7ABAC;
      }

      .br-tablet {
        display: none;

        @include media-down($size-tablet) {
          display: initial;
        }
      }
    }

    &--photo {
      display: block;
      width: 39.12%;

      @include media-down($size-tablet) {
        position: absolute;
        left: 19.7%;
        bottom: 0;
        width: 27.68%;
      }

      @include media-down($size-mobile) {
        width: 67.48%;
        left: auto;
        right: -6%;
      }
    }

    &--description {
      width: 31.78%;

      font-family: 'Onest', sans-serif;
      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        width: 50%;

        font-size: calc(var(--scale) * 18);
      }

      @include media-down($size-mobile) {
        width: 100%;
        margin-top: calc(var(--scale) * 8);
      }
    }
  }
}
</style>
